import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=63095af2&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63095af2')) {
      api.createRecord('63095af2', component.options)
    } else {
      api.reload('63095af2', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=63095af2&", function () {
      api.rerender('63095af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/Settings.vue"
export default component.exports